export type LanguageType = "EN" | "ZHT" 

export enum VersionType {
  ZHCN = "zh-CN",
  ZHTW = "zh-TW",
  ESV = "esv"
}